module.exports = __webpack_public_path__ + "img/no-image.705f383b.svg";